import { Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core"
import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { obtenerMetodosPagoAction, addMetodoPagoAction, addItemsAction } from "../../../../../ducks/cotizadorPaqueteDuck"
import { catTipoPago } from "../../../../../constant/catTipoPago"
import { catCotizador } from "../../../../../constant/constantes"
import { FormatoDiff } from "../../../../../utils/FormatFecha"
import { catTipoItem } from "../../../../../constant/catTipoItem"
const FieldMetodoPago = () => {
    const { listaMetodosPago, metodoPago, fechaSalida, mensualidades, paquete, listaItems } = useSelector(store => store.cotizadorPaquete)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(obtenerMetodosPagoAction())
    }, [dispatch])

    const handleChangeSelectValue = (event) => {
        let metodoPago = event.target.value
        dispatch(addMetodoPagoAction({ metodoPago: metodoPago}))
    }

    return <div style={{ margin: "2% 0" }}>
        <Grid container>
            <Grid item xs={12}>
                <FormControl variant="outlined" style={{ width: "98%" }}>
                    <InputLabel id="lMetodoPago">Metodo pago</InputLabel>
                    <Select
                        labelId="lMetodoPago"
                        id="SMeotodoPago"
                        name="metodoPago"
                        onChange={handleChangeSelectValue}
                        label="Metodo pago"
                        value={metodoPago}
                        disabled={(fechaSalida === '0,0,0') ? true : false}
                    >
                        <MenuItem value="0" disabled>
                            {"Seleccione una opción"}
                        </MenuItem>
                        {listaMetodosPago.map((metodo, index) => {
                            if (mensualidades.length < catCotizador.CANTIDAD_PAGOS_HIBRIDO && metodo.IdCatTipoPago === catTipoPago.HIBRIDO) {
                                return null
                            }
                            if (FormatoDiff({ date: fechaSalida.split(",")[2] }) <= catCotizador.CANTIDAD_DIAS_TARJETA_CREDITO && metodo.IdCatTipoPago === catTipoPago.TARJETA_CREDITO) {
                                return null
                            }
                            return (
                                <MenuItem key={metodo.IdCatTipoPago} value={`${metodo.IdCatTipoPago}`}>
                                    {`${metodo.Nombre}`}
                                </MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    </div>
}
export default FieldMetodoPago